import { isProd } from '~/client/config/appConfig';
import { appRoles } from '~/common/config/constants';
import { User } from '~/common/types/app';

import { createStore, StoreState } from '../createStore';

export interface AppState extends StoreState {
  user?: User;
  loginRedirectUri?: string;
  previousPathname?: string;
  needsClientAuth: boolean;
  isOnCamdenNetwork?: boolean;
  setUser(user?: User): void;
  setLoginRedirectUri(uri?: string): void;
  setNeedsClientAuth(value: boolean): void;
  setPreviousPathname(value?: string): void;
  setIsOnCamdenNetwork(value?: boolean): void;
}

export const useAppStore = createStore<AppState>(
  'app',
  {
    needsClientAuth: true,
  },
  (set) => ({
    setUser: (user) => set({ user }),
    setLoginRedirectUri: (uri) => set({ loginRedirectUri: uri }),
    setNeedsClientAuth: (value) => set({ needsClientAuth: value }),
    setPreviousPathname: (value) => set({ previousPathname: value }),
    setIsOnCamdenNetwork: (value) => set({ isOnCamdenNetwork: value }),
  }),
);

if (!isProd) {
  window.setRole = (...roles) => {
    const allValidRoles = roles.every((role) => appRoles.includes(role));

    if (!allValidRoles) {
      throw Error(`Invalid role specified. Valid roles are ${appRoles.join(', ')}`);
    }
    useAppStore.setState((current) => ({ user: { ...current.user!, roles } }));
  };
}
